import { render } from "./Forbidden.vue?vue&type=template&id=0bfc07aa&scoped=true&ts=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"

import "./Forbidden.vue?vue&type=style&index=0&id=0bfc07aa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfc07aa"]])

export default __exports__